import { createAction, props } from '@ngrx/store';

import { ConnectionStatus } from 'src/app/core/models/session.models';


export const showAppLoader = createAction(
    '[App] Show app loader'
);

export const hideAppLoader = createAction(
    '[App] Hide app loader'
);

export const sessionLoggedIn = createAction(
    '[App] Session logged in'
)

export const sessionLoggedOut = createAction(
    '[App] Session logged out'
)

export const updateAuthToken = createAction(
    '[App] Session auth token updated',
    props<{ token: string | null }>()
)

export const updateIsMobile = createAction(
    '[Breakpoint service] Device type changed',
    props<{ status: boolean }>()
)




export const blockLogin = createAction(
    '[App] Block Login'
)

export const unblockLogin = createAction(
    '[App] Unblock Login'
)